<form [formGroup]="form" (ngSubmit)="onSubmit(form)" errorTailor>
    <div class="modal-header">
        <h4 class="modal-title" id="changeEvaluatorTitle">Change Evaluator</h4>
    </div>
    <div class="modal-body">
        <label class="form-label" for="evaluatorId">Evaluator</label>
        <!-- The modal focuses this select on open, so a blur-triggered message would appear on the first click anywhere else. -->
        <select id="evaluatorId" class="form-select" formControlName="evaluatorId"
            [controlErrors]="{ unchanged: 'Current evaluator still selected. Please select another evaluator.' }"
            [controlErrorsOnBlur]="false">
            <option *ngFor="let evaluator of evaluators" [ngValue]="evaluator.user.userID">{{ evaluator.user.displayName }}</option>
        </select>

        <span class="form-label d-block mt-3" id="sendEmailNotificationLabel">Send Email Notification</span>
        <toggle-indicator formControlName="sendEmailNotification"
            OnLabel="Yes"
            OffLabel="No"
            inputId="sendEmailNotification"
            ariaLabelledBy="sendEmailNotificationLabel"></toggle-indicator>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-success">Submit</button>
        <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
    </div>
</form>
